import React, {useState} from 'react'
import { Button, Modal, Row, Col, Form, Alert } from 'react-bootstrap'
import { documentationService, authService } from '../../../_services'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from "react-i18next";

function CompleteButton(props) {

	const [show, setShow] = useState(false)
	const {t} = useTranslation('common');

	const onClick = () => {
		let documentation = props.documentation
		console.log(documentation)
		let photos = props.photos
		console.log(photos)
        setShow(true)
    }

    const handleSubmit = (event) => {
        event.preventDefault()

        let documentation = props.documentation
        let creator = authService.getCurrentUser().username

	    documentationService.completeWithLicenseCode(props.documentation.id, documentation.licenseCode, creator).then(result => {
	        window.location.reload()
        })
	}

    const handleClose = () => {
		setShow(false)
    }

	return (
        <>
            <Button
	            onClick={onClick}
	            title={t('documentation.complete.button')}
	            variant="outline-secondary">
	            <FontAwesomeIcon icon={faCheck}/> {t('documentation.complete.button')}
	        </Button>
	        <Modal
				style={{overflow: 'scroll'}}
				size="md"
				show={show}
				backdrop={true}
				onShow={() => console.log('onShow')}
				onHide={handleClose}
				animation={false}>
				<Modal.Header closeButton>
					<Modal.Title>
						{t('documentation.complete.title')}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{t('documentation.complete.message')}
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						{t('crudtable.cancel')}
					</Button>
					<Button form='data-form' variant="primary" onClick={handleSubmit}>
						{t('crudtable.ok')}
					</Button>
				</Modal.Footer>
			</Modal>
        </>
    )
}

export default CompleteButton